export default __webpack_public_path__ + "static/media/broccoli.bb245844.svg";